import PropTypes from 'prop-types';
import React from 'react';
import DeadlinePassedText from './status-text/deadline-passed-text';
import ScholarshipsNotYetAvailableText from './status-text/scholarships-not-yet-available-text';
import BoostGpaText from './status-text/boost-gpa';
import CompleteProfileText from './status-text/complete-profile-text';
import SubmittedText from './status-text/submitted-text';
import ChurnedText from './status-text/churned-text';
import BoostTestScoresText from './status-text/boost-test-scores';
import NonUsCitizensOnlyText from './status-text/non-us-citizens-only';
import UsCitizenshipRequired from './status-text/us-citizenship-required';
import UsCitizensOnly from './status-text/us-citizens-only';
import EarningDeadlineSoon from './status-text/earning-deadline-soon-text';
import DeferredSubmissionPeriod from './status-text/deferred-submission-period-text';
import LimitedScholarshipsText from 'src/components/LimitedScholarshipsText';

const propTypes = {
  showTooltipFlag: PropTypes.bool,
  useApplyByTerminology: PropTypes.bool,
  relationship: PropTypes.shape({
    statusType: PropTypes.string.isRequired,
    minGPA: PropTypes.number,
    deadlineDay: PropTypes.number,
    deadlineMonth: PropTypes.number,
    deadlineYear: PropTypes.number,
    deadlineTerm: PropTypes.string,
    deadlineTermYear: PropTypes.number,
  }).isRequired,
};

export const NOT_EARNING_STATUS_COMPONENTS = {
  deadline_passed: DeadlinePassedText,
  scholarships_not_yet_available: ScholarshipsNotYetAvailableText,
  limited_scholarships: LimitedScholarshipsText,
  complete_profile: CompleteProfileText,
  submitted: SubmittedText,
  boost_test_scores: BoostTestScoresText,
  us_citizenship_required: UsCitizenshipRequired,
  us_citizens_only: UsCitizensOnly,
  non_us_citizens_only: NonUsCitizensOnlyText,
  churned: ChurnedText,
  boost_gpa: BoostGpaText,
  earning_deadline_soon: EarningDeadlineSoon,
  submission_period_deferred: DeferredSubmissionPeriod,
};

const onClickHandler = (event) => {
  if (event) {
    event.stopPropagation();
  }
};

const NotEarningText = ({relationship, showTooltipFlag, useApplyByTerminology}) => {
  const Component = NOT_EARNING_STATUS_COMPONENTS[relationship.statusType];
  if (!Component) return null;
  return (
    <Component
      {...relationship}
      showTooltipFlag={showTooltipFlag}
      useApplyByTerminology={useApplyByTerminology}
      onClickHandler={onClickHandler}
    />
  );
};

NotEarningText.propTypes = propTypes;

export default NotEarningText;
